import { Box, Typography } from '@mui/material';

import { FORTA_ERROR } from '../../../utils/colors';

const TimesheetHeading = () => {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography fontWeight="bold">
        Before inputting information, check the observations below
      </Typography>
      <ul>
        <li>
          Therapy hours are logged after session notes are concluded.
          <span style={{ color: FORTA_ERROR, fontWeight: 800 }}>
            {' '}
            Please add any non-therapy hours within this time sheet.
          </span>
        </li>
        <li>Percentage utilization and total hours are estimated.</li>
        <li style={{ color: FORTA_ERROR, fontWeight: 800 }}>
          Pay periods are based on Central Time (CT).
        </li>
      </ul>
    </Box>
  );
};

export default TimesheetHeading;
